export default __webpack_public_path__ + "static/media/img--living-dining-1.2ab9217e.jpg";